import { ResultsGridConfig } from '../../../models';
import { DeepPartial } from '../../../utils';

export const DEFAULT_RESULTS_GRID_CONFIG: DeepPartial<ResultsGridConfig> = {
  grid: {
    columns: 6
  }
};
